/**
 * Get the base URL path for the application.
 * This comes from Vite's `base` config in vite.config.ts.
 * Use this for any absolute paths within the SPA.
 */
export function getBasePath(): string {
  return import.meta.env.BASE_URL
}

/**
 * Create an absolute path within the SPA.
 * Automatically prepends the base path (e.g., '/admin-v2/').
 *
 * @param path - The path relative to the app root (e.g., 'login', 'dashboard')
 * @returns The full path including base (e.g., '/admin-v2/login')
 */
export function appPath(path: string): string {
  const base = getBasePath()
  // Remove leading slash from path if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return `${base}${cleanPath}`
}
